import { render, staticRenderFns } from "./ProductImageSlider.vue?vue&type=template&id=7519f3ae&scoped=true&"
import script from "./ProductImageSlider.vue?vue&type=script&lang=js&"
export * from "./ProductImageSlider.vue?vue&type=script&lang=js&"
import style0 from "./ProductImageSlider.vue?vue&type=style&index=0&id=7519f3ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7519f3ae",
  null
  
)

export default component.exports